import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import TrackingActions from 'medscape/tracking';

export default class UldBanner extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			uldVisible: true,
			textLang: 'en',
			userUpdate: "0",
			nodeHeight: 0
		};
	}
	componentDidMount() {
		this.setHeaderMargin();
	}
	componentDidUpdate(prevProps, prevState) {
		let { nodeHeight, uldVisible } = this.state;
		if(!uldVisible && this.props.feature === "on"){
			ReactDOM.findDOMNode(this).parentNode.style.visibility = "hidden";
		}
		$('header').css('margin-top', nodeHeight);	
	}
	componentWillMount() {
		this.getUserData();
	}
	setHeaderMargin(){
		if(this.props.feature === "off"){
			$('.uld-banner').hide();
			return;
		}
		const nodeHeight = ReactDOM.findDOMNode(this).parentNode.offsetHeight;
		if(this.state.uldVisible){
			this.setState({
				nodeHeight: nodeHeight
			});
		} else {
			ReactDOM.findDOMNode(this).parentNode.style.visibility = "hidden";
			this.setState({
				nodeHeight: 0
			});
		}
	}
	onAccept(){
		TrackingActions.pageLink('ulr_accept');
		this.postUserData();
		this.setState({
			uldVisible: false,
			nodeHeight: 0
		});
	}
	onDecline(){
		TrackingActions.pageLink('ulr_decline');
		this.setState({
			uldVisible: false,
			userUpdate: "0",
			nodeHeight: 0
		});
	}
	getUserData(){
		let uldFlag = "0";
		if(medscape.user.userUldFlag){
			uldFlag = medscape.user.userUldFlag
		}
		if(uldFlag == "0"){
			this.setState({
				uldVisible: true,
				userUpdate: uldFlag
			});
		} else {
			this.setState({
				uldVisible: false,
				userUpdate: uldFlag,
				nodeHeight: 0
			});
		}
	}
	completed(data){
		this.setState({
			userUpdate: "1"
		});
	}
	failed(error){
		console.log(error);
	}
	postUserData(){
		const postUrl = `${medscape.config.apiHost.replace("www","api")}/regservice/registration/pub/update/userAttributes/${medscape.user.uldParam}`,
			sfNumber = `uld-${infosite.config.tracking['SF-Number']}`;
		let	data = {};
		data[sfNumber] = "1";
		$.ajax({
		    type: 'POST',
		    contentType: 'application/json',
    		dataType: 'json',
    		headers: {'isencrypted': false},
		    url: postUrl,
		    data: JSON.stringify(data),
		    xhrFields: {
		        withCredentials: true
		    }
	  	}).then(this.completed(data), this.failed);
	}
	selectLanguage(){
		let userLang = null;
		let currentLanguage = userLang ? userLang : 'en';
		let lngContent = this.props.content.map((data, index) => {
			return data[currentLanguage];
		});
		return lngContent;
	}
	render(){
		const thisProps = this.selectLanguage(),
			langProps = thisProps[0],
			contentProps = {
				className: 'content',
				dangerouslySetInnerHTML: Utils.getDangerousHtml(langProps.mainText)
			},
			acceptProps = {
				className: 'accept',
				dangerouslySetInnerHTML: Utils.getDangerousHtml(langProps.acceptButtonText),
				onClick: this.onAccept.bind(this)
			},
			declineProps = {
				className: 'decline',
				dangerouslySetInnerHTML: Utils.getDangerousHtml(langProps.declineButtonText),
				onClick: this.onDecline.bind(this)
			};
		if(this.props.feature === "off"){
			return null;
		};
		return(
			<div className="uld-container">
				<div {...contentProps}></div>
				<div className="button-container">
					<button {...acceptProps}></button>
					<button {...declineProps}></button>
				</div>
			</div>
		)
	}
}

UldBanner.propTypes={
    "config-id": React.PropTypes.string,
    feature: React.PropTypes.string,
    content: React.PropTypes.array,
}

UldBanner.defaultProps={
    "config-id": '',
    feature: '',
	content: []
}


// WEBPACK FOOTER //
// ./medscape_modules/uld/app.jsx